import { render, staticRenderFns } from "./Divisions.vue?vue&type=template&id=75520668"
import script from "./Divisions.vue?vue&type=script&lang=js"
export * from "./Divisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports